<script setup lang="ts">
import type {
  BreadcrumbCrumbsItem,
  BreadcrumbsProps,
} from '/#/components/base/breadcrumb/breadcrumb'

withDefaults(defineProps<BreadcrumbsProps>(), {
  addHome: true,
})

const sidebarStore = useSidebarStore()
const { smallerThan } = useScreenSize()
const { toggle } = sidebarStore
</script>

<template>
  <nav
    role="navigation"
    class="breadcrumb"
    :class="[noPadding && 'no-padding']"
   
    aria-label="breadcrumbs"
    itemscope
    itemtype="https://schema.org/BreadcrumbList"
  >
    <span
      v-if="smallerThan('lg') && !hideSidebarButton"
      class="resize-wrapper"
     
      @click="toggle"
      @keydown="toggle"
    >
      <Icon name="window-resize-right" />
    </span>

    <ul class="flex items-center">
      <li
        v-if="addHome"
        itemprop="itemListElement"
        itemscope
        itemtype="https://schema.org/ListItem"
        class="breadcrumb-item home"
       
      >
        <Placeload v-if="isLoading" type="line" />
        <Icon v-else name="home-house-line" size="sm" class="home-icon" />
      </li>
      <BreadcrumbItem
        :crumbs="items as BreadcrumbCrumbsItem[]"
        :is-loading="isLoading"
        :responsive="responsive"
      />
      <Badge
        v-if="isBadge && !isLoading"
        :color="badgeColor"
        :label="badgeLabel"
        rounded
        class="h-fit"
       
      />
    </ul>
  </nav>
</template>
